'use client';

import NotFoundPage from '@/components/error/not-found/not-found.component';
import { logError } from '@/helpers/logger';
import { useEffect } from 'react';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        logError('Error Page', error);
    }, [error]);

    return <NotFoundPage error={error} />;
}
